// Utility function to get the label for a given language value
export function getLabelForLanguage(language: string): string {
  const languageLabels: Record<string, string> = {
    en: 'English',
    da: 'Dansk',
  };

  return languageLabels[language] || language;
}